import { defineCustomElement } from 'vue'
import DeathPeddler from './death-peddler.ce.vue'

const element = defineCustomElement(DeathPeddler)

customElements.define('death-peddler', element)
